// Shared logic for vue2-datepicker fields that need an easily-scrollable
// year panel (instead of the default 10-year-per-page grid with decade
// prev/next arrows), so old years (e.g. birth years) are quick to reach.
//
// Usage on a <date-picker> of type "date":
//   :get-year-panel="getYearPanel"
//   popup-class="year-scroll-picker"
//
// Requires the component to have a `fieldsData` prop/data with an optional
// `fieldsData.settings.restrictionType` (+ `customRange`) used to narrow the
// generated year range, matching the same settings used by
// `disabledDateBySettings` in `@/helpers/dateFormater`.
//
// The matching CSS (scrollable + hidden decade header) lives globally in
// `src/assets/scss/components/_input.scss`, since vue2-datepicker appends its
// popup directly to <body> (appendToBody defaults to true), so it is never a
// DOM descendant of the component that renders it.
export const yearScrollDatePicker = {
  methods: {
    getYearPanel() {
      const settings = this.fieldsData?.settings
      const restrictionType = settings?.restrictionType
      const currentYear = new Date().getFullYear()

      let minYear = currentYear - 100
      let maxYear = currentYear + 10

      if (restrictionType === 'custom_range' && settings.customRange) {
        const { startDate, endDate } = settings.customRange
        if (startDate) minYear = new Date(startDate).getFullYear()
        if (endDate) maxYear = new Date(endDate).getFullYear()
      } else if (restrictionType === 'past_only' || restrictionType === 'today_and_past') {
        maxYear = currentYear
      } else if (restrictionType === 'future_only' || restrictionType === 'today_and_future') {
        minYear = currentYear
      }

      const years = []
      for (let year = maxYear; year >= minYear; year--) {
        years.push(year)
      }

      this.$nextTick(this.scrollYearPanelToSelected)

      return years.map(year => [year])
    },
    scrollYearPanelToSelected() {
      const container = document.querySelector('.year-scroll-picker.mx-datepicker-popup .mx-calendar-content')
      const activeCell = container?.querySelector('.mx-table-year td.active')
      if (!container || !activeCell) return

      container.scrollTop = activeCell.offsetTop - (container.clientHeight / 2) + (activeCell.offsetHeight / 2)
    },
  },
}

export const _ = null

